export enum SocketStatus {
  closed,
  connecting,
  error,
  initial,
  ready,
}
export interface ISocketResponseBaseDataModel {
  type: string;
}

export interface IGenericSocketUpdate<T> extends ISocketResponseBaseDataModel {
  data: T;
}

export function createBaseSocketResponse(
  overrides: Partial<ISocketResponseBaseDataModel> = {}
): ISocketResponseBaseDataModel {
  return {
    type: '',
    ...overrides,
  };
}
